function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Dusk Part 1");

var SvgIcons8Error = function SvgIcons8Error(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    width: 128,
    height: 128,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M60.49,59h-57a2,2,0,0,1-1.72-3L30.32,7.9a2,2,0,0,1,3.44,0L62.21,56A2,2,0,0,1,60.49,59Z",
    style: {
      fill: "#ed7899"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.94 53 32.04 16 10.09 53 53.94 53",
    style: {
      fill: "#ffefb8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19 53 20.75 53 35.95 22.6 35 21 19 53",
    style: {
      fill: "#fff6df"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24 53 29.25 53 40.56 30.39 37.71 25.58 24 53",
    style: {
      fill: "#fff6df"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.25 53 51.5 53 52.62 50.77 42.18 33.14 32.25 53",
    style: {
      fill: "#fff6df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,16.94a2,2,0,0,0-3.44,0L10,51a2,2,0,0,0,1.72,3H13a1,1,0,0,0,0-2H11.76L32,18,52.24,52H51a1,1,0,0,0,0,2h1.24A2,2,0,0,0,54,51Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,55.47,34.58,7.39a3,3,0,0,0-5.16,0L.93,55.47A3,3,0,0,0,3.51,60h57a3,3,0,0,0,2.58-4.53Zm-1.71,2a1,1,0,0,1-.87.5h-57a1,1,0,0,1-.86-1.51L31.14,8.41a1,1,0,0,1,1.72,0L61.35,56.49A1,1,0,0,1,61.36,57.5Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,17,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,32,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,37,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,42,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,47,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,22,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,50a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V51A1,1,0,0,0,27,50Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,42a1,1,0,0,0,1-1l.88-12.93a1.93,1.93,0,0,0-.51-1.46,1.86,1.86,0,0,0-1.07-.56,1.93,1.93,0,0,0-.53,0,1.88,1.88,0,0,0-1.22.57,1.93,1.93,0,0,0-.51,1.46L31,41A1,1,0,0,0,32,42Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.04,
    cy: 46,
    r: 2,
    style: {
      fill: "#8d6c9f"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Error, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-Error.71b1d7c5.svg";
export { ForwardRef as ReactComponent };